/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WorkspaceMembersInviteResponseItem,
    WorkspaceMembersInviteResponseItemFromJSON,
    WorkspaceMembersInviteResponseItemFromJSONTyped,
    WorkspaceMembersInviteResponseItemToJSON,
} from './WorkspaceMembersInviteResponseItem';

/**
 * 
 * @export
 * @interface WorkspaceMembersInviteResponse
 */
export interface WorkspaceMembersInviteResponse {
    /**
     * 
     * @type {Array<WorkspaceMembersInviteResponseItem>}
     * @memberof WorkspaceMembersInviteResponse
     */
    results?: Array<WorkspaceMembersInviteResponseItem>;
}

export function WorkspaceMembersInviteResponseFromJSON(json: any): WorkspaceMembersInviteResponse {
    return WorkspaceMembersInviteResponseFromJSONTyped(json, false);
}

export function WorkspaceMembersInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMembersInviteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(WorkspaceMembersInviteResponseItemFromJSON)),
    };
}

export function WorkspaceMembersInviteResponseToJSON(value?: WorkspaceMembersInviteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(WorkspaceMembersInviteResponseItemToJSON)),
    };
}

